


















import Vue from "vue";
import {Component} from "vue-property-decorator";
@Component({
    components: {},
    props: {
        width: {
            type: Number,
            default: 30
        },
        height: {
            type: Number,
            default: 30
        }
    }
})

export default class Loader extends Vue {

}
